const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const ANIMATION_DURATION = 400;
const ANIMATION_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

class KawAccordionItem {
  /** @type {Animation | null} */
  animation = null;
  isClosing = false;
  isExpanding = false;

  /**
   * @param {HTMLDetailsElement} details
   */
  constructor(details) {
    this.details = details;
    this.summary = details.querySelector(':scope > summary');
    this.panel = details.querySelector(':scope > .kaw-accordion__panel');

    if (!(this.summary instanceof HTMLElement) || !(this.panel instanceof HTMLElement)) return;

    this.summary.addEventListener('click', this.onClick);
  }

  /** @param {MouseEvent} event */
  onClick = (event) => {
    if (prefersReducedMotion.matches) return;

    event.preventDefault();
    this.details.style.overflow = 'hidden';

    if (this.isClosing || !this.details.open) {
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  };

  shrink() {
    this.isClosing = true;

    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    this.animation?.cancel();
    this.animation = this.details.animate(
      { height: [startHeight, endHeight] },
      { duration: ANIMATION_DURATION, easing: ANIMATION_EASING }
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    this.details.style.height = `${this.details.offsetHeight}px`;
    this.details.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;

    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.panel.offsetHeight}px`;

    this.animation?.cancel();
    this.animation = this.details.animate(
      { height: [startHeight, endHeight] },
      { duration: ANIMATION_DURATION, easing: ANIMATION_EASING }
    );

    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  /** @param {boolean} open */
  onAnimationFinish(open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.style.height = '';
    this.details.style.overflow = '';
  }
}

/** @param {ParentNode} root */
function initAccordions(root) {
  root.querySelectorAll('.kaw-accordion__item:not([data-kaw-accordion-initialized])').forEach((details) => {
    if (!(details instanceof HTMLDetailsElement)) return;
    details.dataset.kawAccordionInitialized = 'true';
    new KawAccordionItem(details);
  });
}

initAccordions(document);
document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof ParentNode) initAccordions(event.target);
});
